import { create_instance } from '@app/plugins/axios';

export class BaseApiService {
  constructor(opts) {
    this.http = create_instance(opts);
    this.pure_http = create_instance({ ...opts, resource: '' });
    this.full_response_http = create_instance(opts, true);
  }
}
